module.exports = __webpack_public_path__ + "static/media/CTLI_11-315w.cc84e6a2.webp";